import { watchGetPartnerAppCategories } from 'containers/Admin/AppsPartner/store/saga/watchGetPartnerAppCategories';
import { watchGetPartnerApps } from './watchGetPartnerApps';

export const sagaPartnerApps = [watchGetPartnerApps, watchGetPartnerAppCategories];
